


























import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IGuest } from "@/@types/admin/guest/user";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";

import RoomPlan from "../room-plan.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, RoomPlan },
})
export default class GuestRoomResettle extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: String, default: "all" }) registrated!: string;
  @Prop({ type: Object, default: null }) sort!: {
    name: string;
    data: string;
  };
  @Prop({ type: String, default: "" }) search!: string;
  @Prop({ type: Boolean, default: true }) show_plan_guests!: boolean;
  @Prop({ type: Boolean, default: false }) show_plan_cell!: boolean;
}
